var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active === true)?_c('PageLoader',{attrs:{"siloData":_vm.siloData,"appState":_vm.appState,"active":_vm.active,"activator":_vm.type,"pageId":_vm.getPage},on:{"close":function($event){return _vm.$emit('close')},"updateState":_vm.updateState,"refreshData":_vm.refreshData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }